import { FC, useEffect, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import Icon from '../icon/icon';
import Text from '../text/text';

export interface CollapsableToggleItemHeadI {
    id: string;
    checked: boolean;
    indeterminate?: boolean;
    onChange(state: boolean): void;
    onToggle?(state: boolean): void;
    label: string;
    testId?: string;
    disabled?: boolean;
    className?: string;
    defaultToggle?: boolean;
    toggleable?: boolean;
    selectedCount?: string;
}
const CollapsableToggleItemHead: FC<CollapsableToggleItemHeadI> = ({
    id,
    checked = false,
    indeterminate = false,
    onChange,
    onToggle,
    label,
    className,
    testId,
    selectedCount,
    disabled = false,
    defaultToggle = false,
    toggleable = true,
}) => {
    const checkboxRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);
    const [toggle, setToggle] = useState(defaultToggle);
    const handleToggle = () => {
        setToggle((prevState) => {
            onToggle && onToggle(!prevState);
            return !prevState;
        });
    };
    const handleChange = () => {
        onChange(!checked);
    };
    return (
        <div
            className={twMerge(
                'w-full h-12 bg-white flex justify-start items-center  ',
                // 'outline-1 outine-gray-50',
                className,
            )}
            data-test-id={testId}
        >
            <input
                className="mr-2 ml-5"
                id={`item-head-toggle-${id}`}
                ref={checkboxRef}
                type="checkbox"
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
            />
            {label && (
                <Text family="poppins" size="14" lineHeight="20">
                    {label}
                </Text>
            )}
            {selectedCount && (
                <span
                    className="ml-2 w-5 h-5 rounded-full bg-primary-500 text-xs text-white text-center leading-relaxed"
                    data-test-id="selectCount"
                >
                    {selectedCount}
                </span>
            )}
            {toggleable && (
                <button type="button" onClick={handleToggle} className="ml-auto mr-5 " disabled={disabled}>
                    <Icon
                        name="ri-arrow-down-s-line"
                        className={twMerge('leading-4 transition-all', toggle && 'rotate-180')}
                        size={16}
                    />
                </button>
            )}
        </div>
    );
};

export default CollapsableToggleItemHead;
